import logger from './logger';
import dataFetcher from './dataFetcher';
import amplifyService from '../services/Auth/amplifyService';

export type FetchHeader = {
    key: string;
    value: string;
};

const tokenAwareFetcher = (serviceUrl: string, apiKey?: string) => {

    const token = localStorage.getItem('authToken') || undefined;
    const getFetcher = (authToken?: string) => { return dataFetcher(serviceUrl, apiKey, authToken); };

    const fetcherInterceptor = async (
        action: (fetcher: ReturnType<typeof dataFetcher>) => Promise<Response>
    ): Promise<Response> => {

        const fetcher = getFetcher(token);
        const response = await action(fetcher);

        if (![401, 403].includes(response.status)) return response;
 
        logger.info('Token may be expired, attempting refresh...');

        try {
            const newToken = await amplifyService.getCurrentToken();
            // Atualizar localStorage
            localStorage.setItem('authToken', newToken);
            return action(getFetcher(newToken));
        } catch (refreshError) {
            logger.error('Token refresh failed:', refreshError);
            localStorage.removeItem('authToken');
            throw new Error('Authentication failed - please login again');
        }

    }

    return {
        get: async (path: string, searchParams?: URLSearchParams) => {
            return await fetcherInterceptor( async (fetcher) => await fetcher.get(path, searchParams) );
        },
        post: async (path: string, body: object | FormData, isMultipart?: boolean) => {
            return await fetcherInterceptor( async (fetcher) => await fetcher.post(path, body, isMultipart) );
        },
        put: async (path: string, body: object) => {
            return await fetcherInterceptor( async (fetcher) => await fetcher.put(path, body) );
        },
        patch: async (path: string, body: object) => {
            return await fetcherInterceptor( async (fetcher) => await fetcher.patch(path, body) );
        },
        delete: async (path: string, body?: object, searchParams?: URLSearchParams) => {
            return await fetcherInterceptor( async (fetcher) => await fetcher.delete(path, body, searchParams) );
        }
    };
}

export default tokenAwareFetcher;
